export default __webpack_public_path__ + "static/ftp_icon-9a0fc82e031a04bccc63c5f0a8bc204b.png";